// Native
import { useEffect, useState } from "react"

// Components
import { Button, ButtonGroup, ModalBody, ModalFooter, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Form, Modal } from "components"

// Config
import { Mask, API, Enums } from "config"

// Screens
import { Authenticate } from "screens"

export default function Add({ data:consultant, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ form, setForm ] = useState({ operation: 1 })
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState(false)
    const auth = useDisclosure()

    const onChange = ({ target }) => {
        const { name, value } = target
        switch(name){
            case 'amount': setForm({...form, [name]: Mask.price(value)}); break;
            default: setForm({...form, [name]: value}); break;
        }
    }

    const onSubmit = async () => {
        setLoading(true)
        setErrors(false)

        try{
            await API.post(`/consultants/${consultant.data?.id}/bonus`, form)
            toast({ title: 'Movimentação realizada.', status: 'info' })
            props.onClose()
            onSuccess()
            setForm({})
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível adicionar a movimentação agora.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
        <Modal title="Adicionar movimentação" loading={loading} {...props}>
            <ModalBody>
                <Alert status="warning" title="Alteração sensível" children="Você está prestes a lançar uma movimentação de bonificação em um consultor. Esta é uma ação irreversível, fique atento(a)." />

                <Form.Form mt={4} onSubmit={auth.onOpen}>

                    <Form.Select 
                        required
                        label="Operação:" 
                        options={[{ label: '🟢 Adicionar saldo',value: Enums.BonusOperation.ADD }, { label: '🔴 Remover saldo', value: Enums.BonusOperation.REMOVE }]} 
                        name="operation" 
                        error={errors?.operation}
                        onChange={onChange} 
                        fontWeight="bold"
                        isDisabled={loading}
                    />

                    <Form.Text
                        required
                        label="Valor:"
                        name="amount"
                        value={form?.amount}
                        error={errors?.amount}
                        onChange={onChange}
                        isDisabled={loading}
                        size="lg"
                        fontWeight="bold"
                        leftElement={<Text children="R$" />}
                    />

                    <Form.Text
                        required
                        label="Descrição da operação:"
                        name="label"
                        value={form.label}
                        error={errors?.label}
                        onChange={onChange}
                        isDisabled={loading}
                        placeholder="Ex.: Débito referente ao pedido 9383839..."
                        helper="Descreva do que se trata essa movimentação. Esta descrição também aparecerá para o escritório de consultor."
                    />
                </Form.Form>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup size="sm" isDisabled={loading}>
                    <Button children="Adicionar movimentação" isLoading={loading} onClick={auth.onOpen} />
                    <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
                </ButtonGroup>
            </ModalFooter>
        </Modal>

        {/* Screens */}
        <Authenticate onSuccess={onSubmit} {...auth} />
    </>
    )
}